<template>
  <div>
    <md-card class="search-area">
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>search</md-icon>
          검색 조건
        </h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <tr>
            <th>단체명</th>
            <td>
              <input type="text" v-model="query.branchNm" v-on:keyup.enter="searchQuery">
            </td>
            <th>발송교우명</th>
            <td>
              <input type="text" v-model="query.memberHnm" v-on:keyup.enter="searchQuery">
            </td>
<!--            <th>단체등급</th>             -->
<!--            <td>-->
<!--              <input type="text" v-model="query.branchLevel" v-on:keyup.enter="searchQuery">-->
<!--            </td>-->
            <th>국내/해외</th>
            <td>
              <label><input type="radio" value="1" v-model="query.branchLevel" name="branchLevel">국내</label>
              <label><input type="radio" value="2" v-model="query.branchLevel" name="branchLevel">해외</label>
            </td>
            <th>단체구분</th>
            <td>
              <select v-model="query.branchGb">
                <option
                  v-for="item in branchTypeList"
                  :key="item.code"
                  :label="item.codeNm"
                  :value="item.code"
                >
                </option>
              </select>
            </td>
          </tr>
        </table>

      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info md-sm" @click="searchQuery"><md-icon>check</md-icon>검 색</md-button>
        <md-button class="md-default md-sm" @click="clearQuery"><md-icon>clear</md-icon>초기화</md-button>
      </md-card-actions>
    </md-card>
    <!-- 목록 시작 -->
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>
          검색 결과
          <md-button class="md-success md-sm" @click="downloadExcel" :disabled="this.pagination.total === 0">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </h4>

      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다. <span style="color: blue; font-weight: bold; padding-left: 20px;">* 회원수 클릭시 해당 회원 목록으로 이동</span></div>

          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <grid ref="branchGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @click="onClickBranch"
              @response="response"
        ></grid>
      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "GroupSearchListComp",
  props: {
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
    // 단체구분 공통코드 조회
    this.queryBranchTypes();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      // 단체구분 종류
      branchTypeList: [],
      query: {
        branchNm: "",
        memberHnm: "",
        branchGb: ""
      },
    };
  },
  methods: {
    /**
     * 교원 구분 - 공통코드 조회 세팅
     */
    queryBranchTypes() {
      kuaaFnc.fncBranchTypes(null,res => {
        this.branchTypeList = res.data.data.contents;
      });
    },
    /**
     * 검색 조건 초기화
     */
    clearQuery() {
      this.query = {
        branchNm: "",
        memberHnm: "",
        branchGb: ""
      };
    },

    searchQuery() {
      this.doSearch();
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.branchGrid, event, this.pagination);
    },

    doSearch() {
      this.$refs.branchGrid.invoke("readData", 1, this.query);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.branchGrid;
      this.gridProps['columns']= [
          {header: null, name: null, align : 'center', width:50,
            formatter(value) {
              return '<input type="radio" id="radio' + value.row.branchId + '" name="selectedBranch">';
            }
          },
          {header: '단체구분', name: 'branchGbNm', align:'center', width:80, sortable: true},
          {header: '단체명', name: 'branchNm', width:160, sortable: true,
            formatter(value) {
              return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
            }
          },
          {header: '회원수', name: 'memberCnt', align: 'right', width: 80, sortable: true,
            formatter(value) {
              return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
            }
          },
          {header: '발송교우번호', name: 'postmemberNo', align:'center', width:100, sortable: true},
          {header: '발송교우명', name: 'postmemberNm', width:100, sortable: true},
          {header: '우편번호', name: 'zipCd', align:'center', width:100, sortable: true},
          {header: '주소1', name: 'address1', width:250, sortable: true},
          {header: '주소2', name: 'address2', width:250, sortable: true},
          {header: '직장명', name: 'companyNm', width:120, sortable: true},
          {header: '부서', name: 'partNm', width:100, sortable: true},
          {header: '직위', name: 'levelNm', width:100, sortable: true},
          {header: '발송부수', name: 'copies', align:'right', width:80, sortable: true},
          {header: '전화번호', name: 'tel', align:'center', width:100, sortable: true}
        ];
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    onClickBranch (item){
      if(item.instance.getRow(item.rowKey) != null) {
        let obj = item.instance.getRow(item.rowKey);
        // 그리드 선택
        document.getElementById('radio' + obj.branchId).checked = true;
        this.$emit('returnResult', obj, item.columnName);
      }
    },

    downloadExcel() {
      if(this.pagination.total < 1){
        kuaaFnc.showSwal("Excel 다운로드", '검색후 진행해 주세요');
        return false;
      }
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '단체목록';
      kuaaApi.requestFileDownload(
          URL_CONST.BRANCH_EXCEL_DOWNLOAD,
          this.query,
          '단체목록.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>